'use client'

import {
  motion,
  useReducedMotion,
  useScroll,
  useTransform,
} from 'framer-motion'

import { scotlandAssets } from '../scotlandConfig'

const ease = [0.22, 1, 0.36, 1] as const

export function Header() {
  const reduceMotion = useReducedMotion()
  const { scrollY } = useScroll()
  const parallaxY = useTransform(scrollY, [0, 700], ['0%', '-16%'])
  const off = Boolean(reduceMotion)
  const transition = (delay: number) => ({
    duration: off ? 0 : 0.74,
    ease,
    delay: off ? 0 : delay,
  })

  return (
    <header className="relative h-[28rem] overflow-hidden md:h-[38rem]">
      <motion.div
        aria-hidden
        className="pointer-events-none absolute inset-0 -top-[10%] min-h-[120%] will-change-transform"
        style={reduceMotion ? undefined : { y: parallaxY }}
      >
        <img
          src={scotlandAssets.hero}
          alt=""
          fetchPriority="high"
          className="h-full w-full origin-[72%_50%] scale-150 object-cover object-bottom md:origin-center"
        />
      </motion.div>

      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(8,24,19,0.06)_0%,rgba(8,24,19,0.2)_52%,rgba(8,24,19,0.58)_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_28%,transparent_0%,rgba(3,12,9,0.1)_72%)]" />

      <div className="relative z-10 mx-auto flex h-full max-w-(--breakpoint-xl) flex-col items-center justify-end px-4 pb-14 text-center text-white sm:px-6 md:pb-20">
        <motion.div
          className="w-64 drop-shadow-[0_3px_12px_rgba(0,0,0,0.55)] sm:w-80 md:w-[28rem]"
          initial={off ? false : { opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={transition(0.1)}
        >
          <img
            src={scotlandAssets.logo}
            alt="The Retreat Scotland"
            width={598}
            height={292}
            fetchPriority="high"
            className="h-auto w-full"
          />
        </motion.div>
        <motion.div
          className="my-5 h-px w-24 bg-[#c7a56b]"
          initial={off ? false : { opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={transition(0.24)}
        />
        <motion.p
          className="font-scotland text-2xl font-semibold tracking-wide sm:text-3xl md:text-4xl"
          initial={off ? false : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={transition(0.3)}
        >
          2–7 September 2027
        </motion.p>
        <motion.p
          className="mt-3 max-w-2xl text-sm font-medium tracking-wide text-white/88 sm:text-base md:text-lg"
          initial={off ? false : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={transition(0.4)}
        >
          Edinburgh • Highland Perthshire • Loch Lomond
        </motion.p>
      </div>
    </header>
  )
}
